<template>
  <div class="bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <div class="search-wrap flex items-center">
      <el-select
        v-model="deviceName"
        size="small"
        class="ml-5px"
        ref="fatherNode"
        popper-class="visualization-select-popper"
        placeholder="请选择装置"
        filterable
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          prefix-icon="el-icon-search"
          v-model="treeFilterKey"
          size="mini"
          clearable
        ></el-input>
        <el-option hidden key="id" :label="deviceName" :value="deviceName"></el-option>
        <el-tree
          v-loading="deviceTreeLoading"
          ref="smallTreeDom"
          :data="treeData"
          empty-text="暂无数据"
          highlight-current
          :props="defaultTreeProps"
          :expand-on-click-node="false"
          :default-expand-all="false"
          :filter-node-method="filterTreeNode"
          @node-click="treeSelect"
          class="device-tree text-14px"
        >
        </el-tree>
      </el-select>
      <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入管道编码"
        clearable
        class="ml-5px"
      ></el-input>
      <el-button @click="searchHandler" size="mini" type="primary" class="ml-5px">搜索</el-button>
    </div>
    <el-table
      ref="markerTable"
      :data="tableData"
      :row-key="(row) => row.id"
      class="markerTable mt-10px"
      height="calc(100% - 75px)"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      v-loading="tableLoading"
      highlight-current-row
      @row-click="checkDetail"
    >
      <el-table-column show-overflow-tooltip prop="code" label="管道编码"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="管道名称"></el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'

const threeDimensionsApi = new ThreeDimensionsApi()

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    deviceInfo: {
      type: Object,
      defalut: () => {
        return {
          deviceName: null,
          deviceId: null,
          modelId: null,
        }
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      keyWord: null,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      deviceName: '',
      treeFilterKey: '',
      deviceTreeLoading: false,
      treeData: [],
      defaultTreeProps: {
        children: 'children',
        label: 'deviceName',
      },
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
      curRootItem: null,
      isRootModel: false, // 是否是根模型
      modelDetail: {
        filePath: '',
        materialFileId: '',
        modelFileId: '',
      },
      transparency: (60 / 255) * 100,
      currentDeviceNode: null, // 当前装置node
    }
  },
  watch: {},
  computed: {},
  async created() {
    this.getDeviceList()
  },
  beforeDestroy() {
    this.player.Native.ModelTree.setSelectItem(0)
  },
  methods: {
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 获取装置下拉列表
    async getDeviceList() {
      this.deviceTreeLoading = true
      const [err, res] = await threeDimensionsApi.getDeviceList({
        isTree: true,
        body: {
          name: null,
        },
      })
      this.deviceTreeLoading = false
      if (!err && res) {
        const filterTree = (nodes) => {
          const filterNode = (node) => {
            if (!node.modelId) {
              return null
            }
            if (node.children && node.children.length > 0) {
              const filteredChildren = node.children.map(filterNode).filter((child) => {
                return child !== null
              })
              node.children = filteredChildren.length > 0 ? filteredChildren : []
            }

            return node
          }
          return nodes.map(filterNode).filter((node) => {
            return node !== null
          })
        }
        this.treeData = filterTree(res)
        if (res.length) {
          if (this.deviceInfo.deviceId) {
            this.deviceName = this.deviceInfo.deviceName
            this.currentDeviceId = this.deviceInfo.deviceId
            this.currentModelId = this.deviceInfo.modelId
            this.isRootModel = this.deviceInfo.deviceId === res[0].id
          } else {
            this.deviceName = res[0].deviceName
            this.currentDeviceId = res[0].id
            this.currentModelId = res[0].modelId
            this.isRootModel = true
          }
          if (!this.isRootModel) {
            // 如果刚打开弹窗，当前模型不是根模型才进行初始化
            await this.getModelDetail(true)
          } else {
            // 刚打开弹窗，是根模型，更新数据
            const rootInfo = await this.player.Native.ModelTree.getRootItems()
            if (rootInfo?.length && rootInfo[0].item) {
              this.curRootItem = rootInfo[0].item
            }
          }
          this.searchHandler() // 获取全场管线数据
        }
      }
    },
    // 装置树选择
    treeSelect(data) {
      if (!data.modelId) {
        this.$message.warning('该装置未绑定模型')
        return
      }
      if (this.currentDeviceId === data.id) {
        console.log('same device')
        return
      }
      this.$emit('loadingSwitch', { bol: true, title: '正在切换装置' })
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      this.deviceName = data.deviceName
      this.currentDeviceId = data.id
      this.currentModelId = data.modelId
      this.isRootModel = data.id === this.treeData[0].id // 判断是否是根模型
      this.$emit('updateDeviceInfo', {
        deviceName: data.deviceName,
        deviceId: data.id,
        modelId: data.modelId,
      })
      this.$refs.fatherNode.blur()
      this.resetDataAndDestroyNode()
      this.getModelDetail() // 获取模型详情
      this.searchHandler() // 获取管线列表
    },
    // 监听模型切换加载完成操作
    async checkModelLoadEnd(value, handle, name) {
      this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      if (this.isRootModel) {
        const rootInfo = await this.player.Native.ModelTree.getRootItems()
        if (rootInfo?.length && rootInfo[0].item) {
          this.curRootItem = rootInfo[0].item
        }
      } else {
        // 不是根模型进行初始化
        this.initDevice(this.modelDetail)
      }
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 初始化装置状态，
    async initDevice(modelDetail) {
      this.$emit('loadingSwitch', { bol: true, title: '正在初始化装置' })
      try {
        const sceneRootNode = await this.player.Native.NodeProxy.rootNode()
        const modelNode = await this.player.Native.NodeProxy.loadModelNode(
          sceneRootNode,
          modelDetail.filePath,
          modelDetail.modelFileId
        )
        this.currentDeviceNode = modelNode
        const rootInfo = await this.player.Native.ModelTree.getRootItems()
        if (rootInfo?.length && rootInfo[0].item) {
          this.curRootItem = rootInfo[0].item
          // 设置创建的node不可见,原模型半透明
          await this.player.Native.NodeProxy.setNodeVisible(modelNode, false)
          await this.player.Native.ModelTree.setItemAlpha(
            rootInfo[0].item,
            Math.round((this.transparency / 100) * 255)
          )
        }
        this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      } catch (e) {
        this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      }
    },
    // 重置数据，销毁创建的node
    async resetDataAndDestroyNode() {
      this.tableData = [] // 清空表单
      this.keyWord = ''
      await this.destroyNode()
    },
    // 销毁装置node
    async destroyNode() {
      if (this.currentDeviceNode) {
        await this.player.Native.NodeProxy.destroyNode(this.currentDeviceNode)
        this.currentDeviceNode = null
      }
    },
    // 获取模型详情信息
    async getModelDetail(first = false) {
      const [err, res] = await modelApi.get(this.currentModelId)
      if (!err && res?.medias) {
        const modelInfo = _.find(res.medias, ['mediaType', 1])
        const textureInfo = _.find(res.medias, ['mediaType', 2])
        if (modelInfo?.fileInfoId) {
          const modelDetail = {
            filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.pr`,
            materialFileId: textureInfo ? textureInfo.fileInfoId : '',
            modelFileId: modelInfo.fileInfoId,
          }
          this.modelDetail = modelDetail
          if (first) {
            this.initDevice(modelDetail)
          }
          this.$emit('changeModel', modelDetail)
        } else {
          this.$message.warning('模型文件不存在')
        }
      }
    },
    // 获取管线表数据
    async getTableData() {
      const [err, res] = await threeDimensionsApi.getDeviceRelationPipeLineList({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          deviceId: this.currentDeviceId,
          tagCode: this.keyWord ? `%${this.keyWord}%` : '',
        },
      })
      if (!err && res?.code && res.code === '200' && res.data?.items) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      }
      forEach(this.tableData, (item) => {
        const index = findIndex(this.currentPipeActions, ['code', item.tagCode])
        if (index > -1) {
          this.$set(item, 'status', true)
        } else {
          this.$set(item, 'status', false)
        }
      })
    },
    // // 获取管线表数据
    // async getTableData() {
    //   this.tableLoading = true
    //   const [err, res] = await threeDimensionsApi.getPipeLineList({
    //     body: {
    //       pageNo: this.page.pageNo,
    //       pageSize: this.page.pageSize,
    //       code: this.keyWord ? `%${this.keyWord}%` : '',
    //       codes: null,
    //     },
    //   })
    //   this.tableLoading = false
    //   if (!err && res && res.code === '200' && res.data?.items) {
    //     this.tableData = res.data.items
    //     this.page.total = res.data.totalCount
    //   }
    // },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },

    async checkDetail(row) {
      this.$emit('transferEvent', {
        toCom: { code: 'PrtMaterialDetail', origin: 'ValveManagement', name: '防腐保温' },
        type: 'mainComponent',
        props: {
          ...row,
        },
      })
      const itemInfo = await this.player.Native.ModelTree.getItemByCode(row.code)
      if (itemInfo?.item) {
        this.player.Native.ModelTree.setSelectItem(itemInfo.item)
        this.player.Native.Camera.moveToItem(itemInfo.item, 2)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.search-wrap {
  ::v-deep .el-button {
    height: 28px !important;
    border-radius: 5px !important;
  }
  ::v-deep .el-input--small .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
  }
}
.markerTable {
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
</style>
